import { MapComponent } from './../../shared/components/map/map.component';
import { ResultsContainer, HotelPreview } from './results.container';
import { Component, OnInit, HostListener, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IMarker } from '../../shared/components/map/map.component';
import { FilterPipe } from '../../shared/pipes/filter.pipe';
import { Angulartics2 } from 'angulartics2';
import { SharedContainer } from '../../shared/shared.container';
import { SearchEngineService } from '../../core/services/search-engine.service';
import { SortByOptions } from '../../core/models/general.model';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Location, LocationStrategy, PlatformLocation } from '@angular/common';
import { Subscription, interval, fromEvent } from 'rxjs';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { environment } from '../../../environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { ScriptLoader } from '../../shared/components/scriptLoader';


declare const fbq: any;
@Component({
  selector: 'app-hotel-results',
  templateUrl: 'results.component.html',
  styleUrls: ['results.component.css', 'results.component.scss']
})

export class ResultsComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('filterSidebar') elementView: ElementRef;
  @ViewChild('list') listView: ElementRef;
  @ViewChild('mapSection') mapSection: MapComponent;
  @ViewChild('modal', { static: true }) public childModal: ModalDirective;

  offersRequested: Boolean = false;

  offerPage: Number = 1;

  svgPhase: boolean;
  hasSeenAnimation = false;

  isOpen = true;

  isMapDesktopOpen: Boolean = false;

  isResults = true;
  filtersVisible: boolean;
  requestId: string;
  isRequestOpen = false;
  isCatalogCollapsed = true;
  hotelTypes: Array<string>;
  mealTypes: Array<string>;
  exclusiveCategories: Array<string>;
  optionalFacilities: Array<string>;
  personalRequest: boolean;
  lightbox: boolean;
  filters;
  offerFilters;
  offers: Array<any>;
  hotel: Array<any>;
  zoomInfo = 8;
  mapCenter = { latitude: 35.0564782, longitude: 24.2646407 };
  selectedHotel = null;
  openHotelPopup = false;
  userSignup = { email: null, name: null, surname: null, passwd: null, confirmedPassword: null };
  sendRequestClicked = false;
  hotelPreviews: Array<HotelPreview>;
  // hotelPreviewsOffers: Array<HotelPreview>;
  markers: Array<IMarker>;

  totalProps: Number = 0;

  hotelPreviewCollection: Array<any>;
  hotelIdsForRequest: Array<any> = new Array<any>();
  updated;

  requestForSearch;
  // offersEnabled = true;

  stickySidebar = { stickySidebarEnabled: false, top: '', width: 300, position: '', bottom: '' };
  topValue;

  mobileFullsreenWindow = {
    isSortByOpen: false,
    isFilterOptionsOpen: false,
    isMapOpen: false
  };
  pagesLoaded = 1;
  onInit = false;
  public minPrice = 0;
  public maxPrice = 1000;
  public maxPriceOffer = 0;
  loadingResults = false;
  public pages = 0;
  public pagesOffers = 0;
  public totalOffers = 0;
  selectedItem = 0;
  selectedItemOffer = 0;

  sendRequestsToAll: String;
  offersInterval1: any;
  offersInterval2: any;
  clearCatalogInterval: any;
  subscription: Subscription;
  subscription2: Subscription;
  sendRequestAfterLogIn: any = false;

  private cancelBackEvent: Subscription;

  propsForRequest: any = 0;

  totalDays: any = 1;

  expFilter: String;
  noOffersPreview: Boolean = true;

  region: null;

  mailModalShown: Boolean = false;
  offersNumFromParam: Number = 0;

  // initialization for experiences
  experiencesMappingRest = [
    { id: 7, name: 'I love to explore the local cuisine', checked: false, position: 1 },
    { id: 35, name: 'Looking for pet-friendly accommodation', checked: false, position: 2 },
    { id: 19, name: 'Looking to rent a car', checked: false, position: 3 },
    { id: 33, name: 'Concerned about COVID-19 safety protocols', checked: false, position: 4 },
    { id: 14, name: 'Celebrating our time together', checked: false, position: 5 },
    { id: 10, name: 'From massage to beauty services, you name it', checked: false, position: 6 },
    { id: 15, name: 'Looking for a workspace for my business trip', checked: false, position: 7 },
    { id: 4, name: 'Spend precious time with my family', checked: false, position: 8 },
    { id: 12, name: 'Would love for child care or nanny services', checked: false, position: 9 },
    { id: 34, name: 'Looking for a place to host a venue', checked: false, position: 10 },
    { id: 20, name: 'Would love to be transferred from and to the airport', checked: false, position: 11 },
    { id: 6, name: 'Looking for high-end luxurious experiences', checked: false, position: 12 },
    { id: 13, name: 'Hosting our guests and/or our wedding party', checked: false, position: 13 },
    { id: 8, name: 'Experience the local way of life', checked: false, position: 14 },
    { id: 24, name: 'Explore the landmarks, sites and local history', checked: false, position: 15 },
    { id: 5, name: 'On a budget trying to save money', checked: false, position: 16 },
    { id: 2, name: 'Enjoy the warm sun and the golden beaches', checked: false, position: 17 },
    { id: 3, name: 'My ideal scenario is to just lay back and relax', checked: false, position: 18 }
  ];
  experiencesArray: Array<String>;
  experiencesIds: Map<Number, String>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private resultsContainer: ResultsContainer, private angulartics2: Angulartics2, private locationStrategy: LocationStrategy,
    private sharedContainer: SharedContainer, private _snackBar: MatSnackBar, private scriptLoader: ScriptLoader,
    private searchService: SearchEngineService, protected location: Location, private spinner: NgxSpinnerService
  ) {
    this.filtersVisible = true;
    this.hotelTypes = this.resultsContainer.hotelTypes$;
    this.filters = {
      hotelTypes: new Array(),
      mealTypes: new Array(),
      exclusiveCategories: new Array(),
      optionalFacilities: new Array(),
      priceRange: new Array(),
      markersMode: false
    };
    this.hotelPreviews = new Array<HotelPreview>();
    // this.hotelPreviewsOffers = new Array<HotelPreview>();
    this.markers = new Array<IMarker>();
    // this.angulartics2.pageTrack.next({ path: '/results' });
    this.preventBackButton();

    fbq('track', 'Search', { content_ids: this.requestId }); // 2. This will compile now
  }

  preventBackButton() {

    history.pushState(null, null, location.href);
    const currentPath = this.location.path();
    this.cancelBackEvent = fromEvent(window, 'popstate').subscribe(() => {
      Swal.fire({
        title: 'Exit request page?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.isConfirmed) {
          this.cancelBackEvent.unsubscribe();
          this.location.back();
          setTimeout(() => {
            if (this.location.isCurrentPathEqualTo(currentPath)) {
              this.location.back();
            }
          }, 500);
        } else {
          history.pushState(null, null, location.href);
        }
      });
    });

  }

  getNightsSafari(from, to) {
    const fromDate = from.replace(/-/g, '/');
    const toDate = to.replace(/-/g, '/');
    const date1 = new Date(fromDate);
    const date2 = new Date(toDate);
    const timeDiff = Math.abs(date2.getTime() - date1.getTime());
    return Math.ceil(timeDiff / (1000 * 3600 * 24));
  }

  ngOnInit() {
    this.scriptLoader.ngOnInit(); // loads the tawk.to injectable
    const mmSeen = localStorage.getItem('mailModal');
    if (mmSeen === 'seen') {
      this.mailModalShown = true;
    } else {
      window.scroll(0, 0);
    }
    // this.mailModalShown = this.resultsContainer.mailModalSeen;
    this.experiencesArray = new Array<String>();
    this.experiencesIds = new Map<Number, String>();
    if (this.resultsContainer.hasSeenAnimation) {
      this.hasSeenAnimation = true;
    }
    this.resultsContainer.changeHeader('Results');
    this.resultsContainer.hotePreviewsForMaps = new Array<HotelPreview>();
    // this.childModal.show();
    // this.requestId = this.route.pathFromRoot[2].snapshot.paramMap.get('id');
    // this.requestId = this.route.snapshot.params['id'];
    this.showBookInfo();
    // this.resultsContainer.retrieveOffers(this.requestId);
    // this.resultsContainer.retrieveOffersPaginate(this.requestId, 0, 10);
    this.filters.offerType = 'Hotel';
    this.offerFilters = JSON.parse(JSON.stringify(this.filters));
    this.offerFilters.offerType = 'Offer';
    this.resultsContainer.hotelPreviewsArr$.subscribe(hotelPreviews => {
      this.hotelPreviews = hotelPreviews;
      this.hotelPreviews = this.hotelPreviews.slice();
    });

    this.resultsContainer.markersArr$.subscribe(marker => {
      this.markers = marker;
      // this.filterMarkers();
    });

    this.resultsContainer.sortBy$.subscribe(res => {
      this.updated = new Date();
    });
    this.onInit = true;
    this.route.queryParams
      .subscribe(params => {
        if (params.offerpage) {
          this.offerPage = parseInt(params.offerpage, 10);
          this.selectedItemOffer = parseInt(params.offerpage, 10) - 1;
        }
        if (params.offers) {
          this.mailModalShown = true;
          if (parseInt(params.offers, 10) > 0) {
            // this.hasSeenAnimation = true;
            // this.noOffersPreview = false;
            this.offersNumFromParam = parseInt(params.offers, 10);
            this.spinner.show();
          } else if (parseInt(params.offers, 10) === 0) {
            // this.hasSeenAnimation = true;
          }
        }
        // this.childModal.show();
        if (!this.onInit) {
          // this.childModal.show();
        }
        if (params.experiences) {
          const experiences = params.experiences;
          const experiencesSplit = experiences.toString().split(',');
          if (experiencesSplit.length !== this.experiencesArray.length) {
            for (let i = 0; i < experiencesSplit.length; i++) {
              this.experiencesMappingRest.forEach(exp => {
                if (experiencesSplit[i] === exp.id.toString()) {
                  this.experiencesArray.push(exp.name);
                  this.experiencesIds.set(exp.id, exp.name);
                }
              });
            }
          }
        }
        this.sendRequestsToAll = params.sendRequests;
        if (params.checkInDate && params.checkOutDate && params.adults < 100 && params.children) {
          this.totalDays = this.getNightsSafari(params.checkInDate, params.checkOutDate);
          this.fillRequestForSearchFromParams(params); // {order: "popular"}
          this.pagesLoaded = 1;
          this.requestForSearch.page = 1;
          // comment
          /*if (params.pricefilter) {
            // this.minPrice = parseInt(params.pricefilter[0], 10);
            this.maxPrice = parseInt(params.pricefilter[1], 10);
          }*/
          if (params.region) {
            this.region = params.region;
            this.requestForSearch.region = this.region;
            this.requestForSearch.locations = this.region;
          }
          if (params.page) {
            this.requestForSearch.page = params.page;
            this.selectedItem = parseInt(params.page, 10) - 1;
          }
          if (params.accomtype) {
            this.requestForSearch.accomodationtype = parseInt(params.accomtype, 10);
          }
          if (params.dailybudget) {
            this.requestForSearch.dailybudget = parseInt(params.dailybudget, 10);
          }
          if (this.isUserLoggedIn() && params.requestId) {
            this.requestId = params.requestId;
            this.searchService.getOffers(params.requestId, 0, 0, this.offerPage).subscribe((data2: any) => {
              clearInterval(this.clearCatalogInterval);
              if (data2.offers.length > 0) {
                const forDivisionOffers = parseInt(data2.totalOffers, 10) / 10;
                this.maxPriceOffer = data2.maxPrice;
                this.pagesOffers = Math.ceil(forDivisionOffers);
                this.totalOffers = data2.totalOffers;
                this.hasSeenAnimation = true;
                this.noOffersPreview = false;
                this.resultsContainer.storeOffersForMapsPR(data2);
              }
              this.resultsContainer.requestId = params.requestId;
              this.resultsContainer.storeOffersForOffers(data2);
              this.spinner.hide();
              this.clearCatalogInterval = setInterval(() => {
                data2.allOfferIds.forEach(e => {
                  this.hotelPreviews.forEach(e1 => {
                    if (e1.id === e) {
                      const index: number = this.hotelPreviews.indexOf(e1);
                      if (index !== -1) {
                        this.hotelPreviews.splice(index, 1);
                      }
                    }
                  });
                });
              }, 3000);
            });
            this.searchService.getResults(this.requestForSearch).subscribe((data: any) => {
              if (data.offerSize === 0) {
                this.router.navigate(['/search']);
                alert('No villas found. Please try different dates or send your request to support@vervendo.com');
                return;
              }
              this.totalProps = data.allProperties.length;
              const forDivision = parseInt(data.offerSize, 10) / 20;
              this.pages = Math.ceil(forDivision);
              this.maxPrice = parseInt(data.maximumPrice, 10);
              this.resultsContainer.storeOffersNew(data, true, this.requestForSearch);
              this.resultsContainer.storeOffersForMaps(data.allProperties);
              this.onInit = false;
            },
              (error) => console.log(error));
          }
          if (params.requestId) {
            let dateAsked = new Date().getTime();
            this.offersInterval2 = setInterval(() => {
              this.searchService.getIfNewOfferExists(params.requestId, dateAsked)
                .subscribe(result => {
                  if (result) {
                    clearInterval(this.clearCatalogInterval);
                    dateAsked = new Date().getTime();
                    this.searchService.getOffers(params.requestId, 0, this.maxPriceOffer, this.offerPage).subscribe((data3: any) => {
                      this.resultsContainer.requestId = params.requestId;
                      this.resultsContainer.storeOffersForOffers(data3);
                      this.totalOffers = data3.totalOffers;

                      const forDivisionOffers = parseInt(data3.totalOffers, 10) / 10;
                      if (Math.ceil(forDivisionOffers) > this.pagesOffers) {
                        this.pagesOffers = Math.ceil(forDivisionOffers);
                        this.counterOffers(this.pagesOffers);
                      }

                      if (this.noOffersPreview) {
                        this.noOffersPreview = !this.noOffersPreview;
                      }
                      if (data3.maxPrice > this.maxPriceOffer) {
                        this.maxPriceOffer = data3.maxPrice;
                      }
                      this.clearCatalogInterval = setInterval(() => {
                        data3.allOfferIds.forEach(e => {
                          this.hotelPreviews.forEach(e1 => {
                            if (e1.id === e) {
                              const index: number = this.hotelPreviews.indexOf(e1);
                              if (index !== -1) {
                                this.hotelPreviews.splice(index, 1);
                              }
                            }
                          });
                        });
                      }, 3000);
                    },
                      (error1) => console.log(error1));
                  }
                });
            }, 5000);

            if (parseInt(params.requestId, 10) === 2) {
              alert('You can\'t send a request again so soon. Please wait at least 10 minutes and try again');
              this.router.navigate(['/']);
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }

          }
        } else {
          this.router.navigate(['../']);
        }
      });

    const source = interval(2000);
    this.subscription = source.subscribe(val => {
      if (this.isUserLoggedIn && this.sendRequestAfterLogIn) {
        // this.sendRequests('withoutRequest');
        // this.subscription.unsubscribe();
      }
    });
    const source2 = interval(2000);
    this.subscription2 = source2.subscribe(val => {
      this.restoreClickedRequestButtons();
    });
  }
  ngAfterViewInit() {
    if (!this.mailModalShown) {
      this.animationMail();
    }
    if (this.isMobile() && !this.hasSeenAnimation && this.resultsContainer.playAnimation) {
      this.loadAnimationMain();
    } else if (!this.isMobile() && !this.hasSeenAnimation && this.resultsContainer.playAnimation) {
      this.loadAnimationDesktop();
    }
    const svgInterval = setInterval(() => {
      this.svgPhase = this.resultsContainer.svgPhase;
      if (this.svgPhase) {
        setTimeout(() => {
          if (this.isMobile()) {
            if (this.hasSeenAnimation) { return; }
            this.loadAnimationRest();
          } else {
            if (this.hasSeenAnimation) { return; }
            this.loadAnimationRestDesktop();
          }
        }, 100);
        clearInterval(svgInterval);
      }
    }, 2000);
  }


  reset() {
    this.resultsContainer.hotelPreviewsForOffers = null;
    this.resultsContainer.totalCurrentOffers = 0;
    clearInterval(this.offersInterval1);
    clearInterval(this.offersInterval2);
  }

  ngOnDestroy() {
    this.cancelBackEvent.unsubscribe();
    this.resultsContainer.hotelPreviewsForOffers = null;
    this.resultsContainer.totalCurrentOffers = 0;
    clearInterval(this.offersInterval1);
    clearInterval(this.offersInterval2);
    clearInterval(this.clearCatalogInterval);
    this.scriptLoader.ngOnDestroy();
  }

  closeMailModal() {
    this.mailModalShown = !this.mailModalShown;
    this.resultsContainer.mailModalSeen = this.mailModalShown;
    localStorage.setItem('mailModal', 'seen');
  }

  goToNewSearch() {

    if (environment.production) {
      const allowed = this.getRequestExpiryCookie('expiryCookie');
      if (allowed !== null && allowed === false) {
        alert('You recently sent a request. Please wait 10 minutes before sending one again!');
        return;
      } else {
        this.router.navigate(['/search']);
      }
    } else {
      this.router.navigate(['/search']);
    }
  }

  deleteQueryParameterFromCurrentRoute() {
    const params = { ...this.route.snapshot.queryParams };
    delete params.sendRequests;
    this.router.navigate([], { queryParams: params, replaceUrl: true });
  }

  receiveRequestCounter() {
    ++this.propsForRequest;
  }

  receiveRequest(hotelId) {

    if (!this.hotelIdsForRequest.find(i => i === hotelId)) {
      this.hotelIdsForRequest.push(hotelId);
    } else {
      const index = this.hotelIdsForRequest.findIndex(i => i === hotelId);
      this.hotelIdsForRequest.splice(index, 1);
      this.propsForRequest = this.propsForRequest - 2;
    }

  }

  restoreClickedRequestButtons() {
    if (this.hotelIdsForRequest.length > 0) {
      this.hotelIdsForRequest.forEach((hotelid) => {
        const element = <HTMLElement>document.getElementById(hotelid);
        if (element !== null) {
          element.classList.add('requestBtnClicked');
        }
      });
    }
  }

  clickNextStep() {
    if (document.getElementById('tableWrap').style.maxHeight === '500px') {
      document.getElementById('tableWrap').style.maxHeight = '800px';
      document.getElementById('nextStep').style.visibility = 'hidden';
    } else {
      document.getElementById('tableWrap').style.maxHeight = '500px';
    }
  }
  fillRequestForSearch(data) {

    this.requestForSearch = {
      fromdate: data.fromdate,
      todate: data.todate,
      rooms: data.rooms,
      persons: data.roompersons, // this.roompersons
      hotelextras: data.hotelextras,
      offset: 0,
      limit: 20
    };
    this.resultsContainer.requestForSearch = this.requestForSearch;
  }
  fillRequestForSearchFromParams(data) {

    this.requestForSearch = {
      fromdate: data.checkInDate,
      todate: data.checkOutDate,
      rooms: data.rooms,
      adults: data.adults,
      children: data.children,
      hotelextras: data.experiences,
      experiencestitle: data.experiences_title,
      optfacilities: data.optfacilities,
      dailybudget: data.dailybudget,
      personalrequest: data.personalrequest,
      requestexpires: data.requestexpires,
      offset: 0,
      limit: 20,
      sortby: data.sortby,
      pricefilter: data.pricefilter
    };
    this.resultsContainer.requestForSearch = this.requestForSearch;
  }
  toggleFilterOptions() {
    this.filtersVisible = !this.filtersVisible;
  }
  counter(i: number) {
    return new Array(i);
  }
  counterOffers(i: number) {
    return new Array(i);
  }
  filterMarkers() {
    this.filters.markersMode = true;
    const f = new FilterPipe().transform(this.hotelPreviews, this.filters);
    const markers = f.map(
      hotel => this.getMarkers().filter(marker => marker.label === hotel.id));
    this.markers = [].concat.apply([], markers);
    this.filters.markersMode = false;
  }

  filterResults(event) {
    const filterType = event[0];
    const filters = event[1];
    this.filters = filters;
    this.offerFilters = this.filters;
    this.offerFilters = JSON.parse(JSON.stringify(this.filters));
    this.offerFilters.offerType = 'Offer';
    this.resultsContainer.sortHotelsBy(filterType, filters);
    if (filterType === SortByOptions.SORT_BY_PRICE) {
      this.requestForSearch.pricefilter = filters.priceRange;
      this.searchService.getResults(this.requestForSearch).subscribe((data: any) => {
        const forDivision = parseInt(data.offerSize, 10) / 20;
        this.pages = Math.ceil(forDivision);
        this.resultsContainer.storeOffersNew(data, false, this.requestForSearch);
        this.resultsContainer.storeOffersForMaps(data.allProperties);
        this.filterOffers(filters.priceRange);
      },
        (error) => console.log(error));
    }
    this.filterMarkers();
    this.updated = new Date();
  }
  filterOffers(event) {
    const minPrice = event[0][0];
    const maxPrice = event[0][1];
    this.route.queryParams.subscribe(params => {
      if (params.requestId) {
        this.searchService.getOffers(params.requestId, minPrice, maxPrice, this.offerPage).subscribe((data3: any) => {
          this.resultsContainer.requestId = params.requestId;
          this.resultsContainer.storeOffersForOffers(data3);
        },
          (error1) => console.log(error1));
      }
    });
  }
  filterExp(event) {
    const filter = event;
    this.route.queryParams.subscribe(params => {
      if (params.requestId) {
        // work here
        this.expFilter = filter;
        this.resultsContainer.filterOffersByExp(this.expFilter);
      }
    });
  }
  loadMore() {
    this.loadingResults = true;
    this.pagesLoaded++;
    this.resultsContainer.retrieveOffersPaginate(this.requestId, (this.pagesLoaded - 1) * 10, 10);
    this.hotelPreviews = this.getHotePreviews();
    this.hotelPreviews = this.hotelPreviews.slice();
    this.loadingResults = false;
  }
  loadMoreNew() {
    this.loadingResults = true;
    this.pagesLoaded++;
    this.requestForSearch.offset = (this.pagesLoaded - 1) * 10;
    this.searchService.getResults(this.requestForSearch).subscribe((data: any) => {
      if (data.inCanNotAccommodate) {
        this.requestForSearch.offset = 10 - data.offersSize;
      }
      this.resultsContainer.storeOffersNew(data, false, this.requestForSearch);
      this.hotelPreviews = this.getHotePreviews();
      this.hotelPreviews = this.hotelPreviews.slice();
      this.loadingResults = false;
    },
      (error) => console.log(error));
    // this.resultsContainer.retrieveOffersPaginate(this.requestId, (this.pagesLoaded - 1) * 10, 10);
  }
  pageNew(i, main) {
    this.loadingResults = true;
    this.pagesLoaded++;
    this.requestForSearch.page = i + 1;
    if (main) {
      this.selectedItem = i;
    } else {
      this.selectedItem = i - 1;
    }
    let page = i + 1;
    if (page === 0) {
      page = 1;
    }
    this.router.navigate([], { relativeTo: this.route, queryParams: { page: page }, queryParamsHandling: 'merge' });

  }

  pageNewOffers(i, main) {
    this.spinner.show();
    this.loadingResults = true;
    this.requestForSearch.offerpage = i + 1;
    if (main) {
      this.selectedItemOffer = i;
    } else {
      this.selectedItemOffer = i - 1;
    }
    let page = i + 1;
    if (page === 0) {
      page = 1;
    }

    this.router.navigate([], { relativeTo: this.route, queryParams: { offerpage: page }, queryParamsHandling: 'merge' });

    this.spinner.hide();

  }

  isMapReady() {
    if (this.resultsContainer.getMapCenter().latitude !== 0) { return true; }
  }

  getMealTypes = () => this.resultsContainer.mealTypes$;
  getHotelTypes = () => this.resultsContainer.hotelTypes$;
  getExclusiveCategories = () => this.resultsContainer.exclusiveCategories$;
  getOptionalFacilities = () => this.resultsContainer.optionalFacilities$;
  getPriceRange = () => this.resultsContainer.priceRange$;
  getHotePreviews = () => this.resultsContainer.hotePreviews;
  getHotelOffers = () => this.resultsContainer.hotelPreviewsForOffers;
  getMarkers = () => this.resultsContainer.markers;
  getMapCenter = () => this.resultsContainer.getMapCenter();
  getHotels = () => this.resultsContainer.getHotels();
  getHotelsForMaps = () => this.resultsContainer.getHotelsForMaps();
  getUserInfo = () => this.resultsContainer.userLoggedIn;
  getRequestInfo = () => this.resultsContainer.myRequestInfo;
  getSelectedExperiences = () => {
    return this.experiencesArray;

  }

  isMobile = () => (window.innerWidth < 992) ? true : false;

  getOffersNum() {
    let offerNum = 0;
    this.hotelPreviews.forEach(hotel => {
      if (hotel.offerType === 'Offer') {
        offerNum++;
      }
    });
    return offerNum;
  }

  showBookInfo() {
    const w = document.getElementById('bookInfo');
    if (w) {
      w.style.visibility = 'visible';
    }
  }

  changeOfferType() {
    this.filters.offerType = 'Hotel';
    // this.offersEnabled = true;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.doSomething(event);
  }
  @HostListener('window:scroll', ['$event'])
  doSomething(event) { }

  isUserLoggedIn() {
    return this.sharedContainer.isLoggedIn$;
  }

  getNights(from, to) {
    const date1 = new Date(from);
    const date2 = new Date(to);
    const timeDiff = Math.abs(date2.getTime() - date1.getTime());
    return Math.ceil(timeDiff / (1000 * 3600 * 24));
  }

  getAdults() {
    return this.resultsContainer.myRequestInfo.roompersons.reduce((sum, current) => (sum + parseInt(current.adults, 10)), 0);
  }

  getChildren() {
    return this.resultsContainer.myRequestInfo.roompersons.reduce((sum, current) => (sum + current.children.length), 0);
  }

  getIsResults() {
    return this.isResults;
  }

  getChildrenAges() {
    let childrenNum = '';
    if (this.resultsContainer.myRequestInfo.roompersons.length > 0) {
      const roomPeople = this.resultsContainer.myRequestInfo.roompersons;
      roomPeople.map(info => info.children.map(age => (childrenNum += ', ' + age)));
    }
    if (childrenNum.length > 0) { childrenNum = childrenNum.substring(2, childrenNum.length); }
    return childrenNum;
  }

  formatDate(date) {
    const monthNames = [
      'Jan', 'Feb', 'Mar',
      'Apr', 'Ma', 'Jun', 'Jul',
      'Aug', 'Sep', 'Oct',
      'Nov', 'Dec'
    ];
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    return day + ' ' + monthNames[monthIndex] + ' ' + year;
  }

  getFormatedDate(date) {
    const selectedDate = new Date(date);
    return (selectedDate.getDate() + '/'
      + (selectedDate.getMonth() + 1) + '/'
      + selectedDate.getFullYear());
  }

  getPlainDate(date) {
    return new Date(date);
  }

  getDate(unixTime) {
    return this.formatDate(new Date(unixTime));
  }

  toggleRequestModal() {
    this.isRequestOpen = !this.isRequestOpen;
  }

  openModalLogin() {
    this.resultsContainer.openLoginModal();
  }

  signUp() {
    if (this.isPasswordMatch()) {
      delete this.userSignup.confirmedPassword;
      this.resultsContainer.signupUser(this.userSignup);
    } else {
      alert('Passwords do not Match!!');
    }
  }

  isPasswordMatch() {
    if (this.userSignup.passwd === this.userSignup.confirmedPassword) {
      return true;
    }
    return false;
  }

  zoomToHotel(hotel) {
    // this.router.navigate(['results/' + this.requestId + hotel.offerId]);
    // this.zoomInfo = 16;
    // this.mapCenter.latitude = hotel.lat;
    // this.mapCenter.longitude = hotel.lang;
    // this.selectedHotel = hotel;
    // this.mapSection.clickedHotel(hotel);
    // this.zoomInfo = 9;
  }

  openFilterMenu() {
    document.getElementById('filterSidebar').style.width = '100%';
    this.mobileFullsreenWindow.isFilterOptionsOpen = true;
  }

  openSortByMenu() {
    document.getElementById('filterSidebar').style.width = '100%';
    this.mobileFullsreenWindow.isSortByOpen = true;
  }

  openPropertyList() {
    const allHotels = <HTMLElement>document.getElementById('all-hotels');
    this.isOpen = !this.isOpen;
    if (!this.isOpen) {
      setTimeout(() => {
        allHotels.scrollIntoView({ behavior: 'smooth' });
      }, 200);
    }
  }

  closeFilterWindow(event) {
    if (event === 'closeFilters') {
      this.mobileFullsreenWindow.isFilterOptionsOpen = false;
      document.getElementById('filterSidebar').style.width = '0';
    } else if (event === 'closeSortBy') {
      this.mobileFullsreenWindow.isSortByOpen = false;
      document.getElementById('filterSidebar').style.width = '0';
    } else if (event === 'map') {
      this.mobileFullsreenWindow.isMapOpen = false;
      document.getElementById('right').style.width = '0';
    }
  }

  openMapWindow() {
    document.getElementById('right').style.width = '100%';
    this.mobileFullsreenWindow.isMapOpen = true;
    setTimeout(() => {
      document.getElementById('menu-header').style.marginTop = '6rem';
    }, 200);
  }

  openMapWindowDesktop() {
    if (this.isMapDesktopOpen) {
      this.isMapDesktopOpen = false;
    } else {
      this.isMapDesktopOpen = true;
    }
  }

  loadAnimationMain() {
    gsap.registerPlugin(ScrollTrigger);
    const tl = gsap.timeline();

    // add tweens that will play in direct succession.

    // success panel
    tl.fromTo(
      '#success_panel',
      { scale: 0 },
      { scale: 1, transformOrigin: 'top 50%' }
    );
    tl.fromTo(
      '#success_illustration',
      { y: -350 },
      { y: 0, duration: 1, opacity: 1, ease: 'elastic.out(1, 0.7)' }
    );
    tl.fromTo('#success_screen', { opacity: 0 }, { duration: 0.5, opacity: 1 });
    tl.fromTo('#success_circle', { opacity: 0 }, { duration: 0.5, opacity: 1 });
    tl.fromTo('#success_checkmark', { opacity: 0 }, { duration: 0.5, opacity: 1 });
    tl.fromTo(
      '#success_title',
      { opacity: 0, y: 100 },
      { opacity: 1, y: 0, ease: 'elastic.out(1, .8)' }
    );
    tl.fromTo(
      '#success_desc',
      { opacity: 0, y: 100 },
      { opacity: 1, y: 0, ease: 'elastic.out(1, .8)' }
    );
    // request panel
    tl.fromTo(
      '#request_panel',
      { scale: 0 },
      { scale: 1, transformOrigin: 'top 50%' }
    );
    tl.fromTo(
      '#request_1',
      { opacity: 0 },
      {
        duration: 0.5,
        opacity: 1,
        scale: 1.1,
        transformOrigin: '50% 50%',
        ease: 'power4.out'
      }
    );
    tl.fromTo(
      '#request_2',
      { opacity: 0 },
      {
        duration: 0.5,
        opacity: 1,
        scale: 1.1,
        transformOrigin: '50% 50%',
        ease: 'power4.out'
      }
    );
    tl.fromTo(
      '#request_3',
      { opacity: 0 },
      {
        duration: 0.5,
        opacity: 1,
        scale: 1.1,
        transformOrigin: '50% 50%',
        ease: 'power4.out'
      }
    );
    tl.fromTo(
      '#request_4',
      { opacity: 0 },
      {
        duration: 0.5,
        opacity: 1,
        scale: 1.1,
        transformOrigin: '50% 50%',
        ease: 'power4.out'
      }
    );
    tl.fromTo(
      '#request_5',
      { opacity: 0 },
      {
        duration: 0.5,
        opacity: 1,
        scale: 1.1,
        transformOrigin: '50% 50%',
        ease: 'power4.out'
      }
    );
    tl.fromTo(
      '#request_6',
      { opacity: 0 },
      {
        duration: 0.5,
        opacity: 1,
        scale: 1.1,
        transformOrigin: '50% 50%',
        ease: 'power4.out'
      }
    );
    tl.fromTo(
      '#request_7',
      { opacity: 0 },
      {
        duration: 0.5,
        opacity: 1,
        scale: 1.1,
        transformOrigin: '50% 50%',
        ease: 'power4.out'
      }
    );
    tl.fromTo(
      '#request_title',
      { opacity: 0, y: 100 },
      { opacity: 1, y: 0, ease: 'elastic.out(1, .8)' }
    );
    tl.fromTo(
      '#request_desc',
      { opacity: 0, y: 100 },
      { opacity: 1, y: 0, ease: 'elastic.out(1, .8)' }
    );
    // email panel
    tl.fromTo(
      '#email_panel',
      { scale: 0 },
      { scale: 1, transformOrigin: 'top 50%' }
    );
    tl.fromTo(
      '#email',
      { x: -450 },
      { x: 0, duration: 1, opacity: 1, ease: 'elastic.out(1, 0.7)' }
    );
    tl.fromTo(
      '#alert',
      { x: 450 },
      { x: 0, duration: 1, opacity: 1, ease: 'elastic.out(1, 0.9)' }
    );
    tl.fromTo(
      'test',
      { rotate: 0, transformOrigin: 'center' },
      {
        rotate: -10,
        duration: 0.65,
        yoyo: true,
        transformOrigin: 'center',
        repeat: -1,
        ease: 'linear'
      }
    );
    tl.fromTo(
      '#text-wrapper',
      { y: 250 },
      { y: 0, duration: 1, opacity: 1, ease: 'elastic.out(1, 0.9)' }
    );

    // wait panel
    tl.fromTo('#wait_panel', { scale: 0 }, { scale: 1 });
    tl.fromTo('.email-icon', { x: -650 }, { x: 0, duration: 1, opacity: 1, ease: 'elastic.out(1, 0.7)' });
    tl.fromTo('.alert-icon', { x: 650 }, { x: 0, duration: 1, delay: .5, opacity: 1, ease: 'elastic.out(1, 0.7)' });
    tl.fromTo('#wait_title', { opacity: 0, y: 100 }, { opacity: 1, y: 0, ease: 'elastic.out(1, .8)' });
    tl.fromTo('#wait_desc', { opacity: 0, y: 100 }, { opacity: 1, y: 0, ease: 'elastic.out(1, .8)' });
    tl.fromTo('#catalog_button', { opacity: 0, y: 100 }, { opacity: 1, y: 0, ease: 'elastic.out(1, .8)' });

    tl.fromTo('#browse-button', { y: 250 }, { y: 0, duration: 1, opacity: 1, ease: 'elastic.out(1, 0.9)' });


    // sun animation
    gsap.to('.sun-rays', { repeat: -1, duration: 20, rotate: 360, transformOrigin: '50% 50%', ease: 'none' });

    // water animation
    gsap.to('#turbwave', { attr: { 'baseFrequency': 0.01 }, duration: 30, repeat: -1, yoyo: true });

    // this.resultsContainer.hasSeenAnimation = true;

  }

  loadAnimationRest() {
    if (this.hasSeenAnimation) { return; }
    gsap.registerPlugin(ScrollTrigger);
    const tl = gsap.timeline();

    // add tweens that will play in direct succession.

    // offer panel
    tl.fromTo('#offer_panel', { scale: 0 }, { scale: 1, transformOrigin: 'top 50%' });
    tl.fromTo('#offer_desk', { x: -350 }, { x: 0, duration: 1, opacity: 1, ease: 'elastic.out(1, 0.7)' });
    tl.fromTo('#offer_hotelier', { x: -350 }, { x: 0, duration: 1, opacity: 1, ease: 'elastic.out(1, 0.7)' });
    tl.fromTo('#offer_lines', { y: -350, opacity: 0 }, { y: 0, duration: 0.1, opacity: 1, ease: 'elastic.out(1, 0.7)' });
    tl.fromTo('#offer_stars', { y: -350, opacity: 0 }, { y: 0, duration: 0.1, opacity: 1, ease: 'elastic.out(1, 0.7)' });
    tl.fromTo('#offer_rays', { y: -350, opacity: 0 }, { y: 0, duration: 0.1, opacity: 1, ease: 'elastic.out(1, 0.7)' });
    tl.fromTo('#offer_circles', { y: -350, opacity: 0 }, { y: 0, duration: 0.1, opacity: 1, ease: 'elastic.out(1, 0.7)' });
    tl.fromTo('#offer_title', { opacity: 0, y: 100 }, { opacity: 1, y: 0, ease: 'elastic.out(1, .8)' });
    tl.fromTo('#offer_desc', { opacity: 0, y: 100 }, { opacity: 1, y: 0, ease: 'elastic.out(1, .8)' });

    // browse panel
    tl.fromTo('#browse_panel', { scale: 0 }, { scale: 1, transformOrigin: 'top 50%' });
    tl.fromTo('#browse_phone', { y: -350 }, { y: 0, duration: 1, opacity: 1, ease: 'elastic.out(1, 0.7)' });
    tl.fromTo('#browse_options', { y: 50, opacity: 0 }, { y: 0, duration: 1, opacity: 1, ease: 'elastic.out(1, 0.7)' });
    tl.fromTo('#browse_button', { y: 350 }, { y: 0, duration: 1, opacity: 1, ease: 'elastic.out(1, .8)' });
    tl.fromTo('#browse_text', { y: 350 }, { y: 0, duration: 1, opacity: 1, ease: 'elastic.out(1, .8)' });

  }

  loadAnimationDesktop() {
    if (this.hasSeenAnimation) { return; }
    // success panel
    const tl = gsap.timeline();
    tl.fromTo('#success_panel', { scale: 0 }, { scale: 1 });
    tl.fromTo('#success_illustration', { y: -350 }, { delay: 1, y: 0, duration: 1, opacity: 1, ease: 'elastic.out(1, 0.7)' });
    tl.to('#success_screen', { duration: .5, opacity: 1 });
    tl.to('#success_circle', { duration: .5, opacity: 1 });
    tl.to('#success_checkmark', { duration: .5, opacity: 1 });
    tl.fromTo('#success_title', { opacity: 0, y: 100 }, { opacity: 1, y: 0, ease: 'elastic.out(1, .8)' });
    tl.fromTo('#success_desc', { opacity: 0, y: 100 }, { opacity: 1, y: 0, ease: 'elastic.out(1, .8)' });

    // request panel
    tl.fromTo('#request_panel', { scale: 0 }, { scale: 1 });
    tl.fromTo('#request_1', { opacity: 0 }, {
      delay: 0.5, duration: .5, opacity: 1, scale: 1.1,
      transformOrigin: '50% 50%', ease: 'power4.out'
    });
    tl.fromTo('#request_2', { opacity: 0 }, { duration: .5, opacity: 1, scale: 1.1, transformOrigin: '50% 50%', ease: 'power4.out' });
    tl.fromTo('#request_3', { opacity: 0 }, { duration: .5, opacity: 1, scale: 1.1, transformOrigin: '50% 50%', ease: 'power4.out' });
    tl.fromTo('#request_4', { opacity: 0 }, { duration: .5, opacity: 1, scale: 1.1, transformOrigin: '50% 50%', ease: 'power4.out' });
    tl.fromTo('#request_5', { opacity: 0 }, { duration: .5, opacity: 1, scale: 1.1, transformOrigin: '50% 50%', ease: 'power4.out' });
    tl.fromTo('#request_6', { opacity: 0 }, { duration: .5, opacity: 1, scale: 1.1, transformOrigin: '50% 50%', ease: 'power4.out' });
    tl.fromTo('#request_7', { opacity: 0 }, { duration: .5, opacity: 1, scale: 1.1, transformOrigin: '50% 50%', ease: 'power4.out' });
    tl.fromTo('#request_title', { opacity: 0, y: 100 }, { opacity: 1, y: 0, ease: 'elastic.out(1, .8)' });
    tl.fromTo('#request_desc', { opacity: 0, y: 100 }, { opacity: 1, y: 0, ease: 'elastic.out(1, .8)' });

    // wait panel
    tl.fromTo('#wait_panel', { scale: 0 }, { scale: 1 });
    tl.fromTo('#wait_clock', { x: -350 }, { x: 0, duration: 1, opacity: 1, ease: 'elastic.out(1, 0.7)' });
    tl.fromTo('#wait_brochure', { x: 350 }, { x: 0, duration: 1, opacity: 1, ease: 'elastic.out(1, 0.7)' });
    tl.fromTo('#wait_title', { opacity: 0, y: 100 }, { opacity: 1, y: 0, ease: 'elastic.out(1, .8)' });
    tl.fromTo('#wait_desc', { opacity: 0, y: 100 }, { opacity: 1, y: 0, ease: 'elastic.out(1, .8)' });
    tl.fromTo('#catalog_button', { opacity: 0, y: 100 }, { opacity: 1, y: 0, ease: 'elastic.out(1, .8)' });

    // clock animation
    gsap.to('#wait_min', { repeat: -1, duration: 30, rotate: 360, transformOrigin: '50% bottom', ease: 'none' });
    gsap.to('#wait_hr', { repeat: -1, duration: 150, rotate: 360, transformOrigin: '1% right', ease: 'none' });

    // sun animation
    gsap.to('.sun-rays', { repeat: -1, duration: 20, rotate: 360, transformOrigin: '50% 50%', ease: 'none' });

    // water animation
    // gsap.to('#turbwave', { attr: { 'baseFrequency': 0.04, numOctaves: 2 }, duration: 15, repeat: -1, yoyo: true });

    // this.resultsContainer.hasSeenAnimation = true;

  }

  loadAnimationRestDesktop() {
    if (this.hasSeenAnimation) { return; }
    const tl = gsap.timeline();

    // offer panel
    tl.fromTo('#offer_panel', { scale: 0 }, { scale: 1 });
    tl.fromTo('#offer_desk', { x: -350 }, { x: 0, duration: 1, opacity: 1, ease: 'elastic.out(1, 0.7)' });
    tl.fromTo('#offer_hotelier', { x: 350 }, { x: 0, duration: 1, opacity: 1, ease: 'elastic.out(1, 0.7)' });
    tl.fromTo('#offer_lines', { y: 50, opacity: 0 }, { y: 0, duration: 0.3, opacity: 1, ease: 'expo' });
    tl.fromTo('#offer_stars', { y: 50, opacity: 0 }, { y: 0, duration: 0.3, opacity: 1, ease: 'expo' }, '-=0.3');
    tl.fromTo('#offer_rays', { y: 50, opacity: 0 }, { y: 0, duration: 0.3, opacity: 1, ease: 'expo' });
    tl.fromTo('#offer_circles', { y: 50, opacity: 0 }, { y: 0, duration: 0.3, opacity: 1, ease: 'expo' }, '-=0.3');
    tl.fromTo('#offer_title', { opacity: 0, y: 100 }, { opacity: 1, y: 0, ease: 'elastic.out(1, .8)' });
    tl.fromTo('#offer_desc', { opacity: 0, y: 100 }, { opacity: 1, y: 0, ease: 'elastic.out(1, .8)' });

    // browse panel
    tl.fromTo('#browse_panel', { scale: 0 }, { scale: 1 });
    tl.fromTo('#browse_phone', { y: -350 }, { y: 0, duration: 1, opacity: 1, ease: 'elastic.out(1, 0.7)' });
    tl.fromTo('#browse_options', { y: 50, opacity: 0 }, { y: 0, opacity: 1, ease: 'elastic.out(1, 0.7)' });
    tl.fromTo('#browse_button', { y: 350 }, { y: 0, opacity: 1, ease: 'elastic.out(1, .8)' });
    tl.fromTo('#browse_desc', { y: 350 }, { y: 0, opacity: 1, ease: 'elastic.out(1, .8)' });
  }

  animationMail() {
    const modal = gsap.timeline();

    modal.fromTo('.popup', { y: 550, opacity: 0 },
      { y: 0, opacity: 1, duration: 1, ease: 'elastic.out(0.7, 1)' });
  }

  browseCatalog(el: HTMLElement) {
    if (el.classList.contains('section__catalog')) {
      if (this.isOpen) {
        this.openPropertyList();
      } else {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }

  angulartics2Track(action: string) {
    this.angulartics2.eventTrack.next({ action: action });
  }

  setRequestExpiryCookie(key, value, ttl) {

    const now = new Date();

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  getRequestExpiryCookie(key) {
    const itemStr = localStorage.getItem(key);
    // if the item doesn't exist, return null
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  }

}
